import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

  itemCount: number;
  btnText: string = 'Add an Item';    // Add this line
  goalText: string = 'My first life goal';    // Add this
  goals = [];
  constructor() { }

  ngOnInit() {
    this.itemCount = this.goals.length;
  }
  
  addItem() {
    this.goals.push(this.goalText);
    this.goalText = '';
    this.itemCount = this.goals.length;
  }
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/test/test.component.ts